import './TkgmParsel.scss';
import { Dialog } from 'primereact/dialog';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { setSelectedFeature } from '../../../features/selectionSlice';
import { InputText } from 'primereact/inputtext';
import { setFitGeom, setHighlightGeom } from '../../../features/mapSlice';
import { InputNumber } from 'primereact/inputnumber';
import { InputTextarea } from 'primereact/inputtextarea';

export default function TkgmParsel() {
    const dispatch = useAppDispatch();
    const selectedFeature = useAppSelector((state) => state.selectionState.selectedFeature);

    const onCloseParselInfo = () => {
        dispatch(setSelectedFeature(null));
        dispatch(setFitGeom(null));
        dispatch(setHighlightGeom(null));
    };
    return (
        <>
            <Dialog
                header="TKGM Parsel Bilgi"
                visible={selectedFeature}
                style={{ width: '30vw' }}
                position="left"
                onHide={() => onCloseParselInfo()}
            >
                <div className="field-container">
                    <div className="field">
                        <label>Taşınmaz No</label>
                        <InputText disabled value={selectedFeature.get('tapu_zemin_ref')} />
                    </div>
                    <div className="field">
                        <label>İl</label>
                        <InputText disabled value={selectedFeature.get('il_ad')} />
                    </div>
                </div>
                <div className="field-container">
                    <div className="field">
                        <label>İlçe</label>
                        <InputText disabled value={selectedFeature.get('ilce_ad')} />
                    </div>
                    <div className="field">
                        <label>Mahalle</label>
                        <InputText disabled value={selectedFeature.get('mahalle_ad')} />
                    </div>
                </div>
                <div className="field-container">
                    <div className="field">
                        <label>Tapu Alan</label>
                        <InputNumber disabled value={selectedFeature.get('parsel_alani')} />
                    </div>
                    <div className="field">
                        <label>Ada/Parsel</label>
                        <InputText disabled value={`${selectedFeature.get('ada')}/${selectedFeature.get('parsel')}`} />
                    </div>
                </div>
                <div className="field-container">
                    <div className="field">
                        <label>Parsel Cinsi</label>
                        <InputTextarea disabled value={selectedFeature.get('tapu_cins_aciklama')} />
                    </div>
                </div>
            </Dialog>
        </>
    );
}
